<template>
  <DBox
    :id="'cmp-catalog-products-product_setup'"
    :addButton="false"
    :topRightMenu="[
      {
        text: 'Metadata',
        icon: 'Help2.svg',
        value: 'question',
      },
    ]"
    :noSeparator="true"
  >
    
    
    <ExpandBox
      v-for="endpoint in allItemMetadataEndpoints"
      :title="endpoint.metadata_endpoint"
      :key="endpoint.metadata_endpoint"
      maximized
    >
      
      <template v-slot:body>
        <!-- {{lastItemIndex}} -->
        <template
          v-for="item in allItemMetadata.filter(
            (e) => e.metadata_endpoint == endpoint.metadata_endpoint
          )"
        >
          <div class="ut-flex" :key="item.metadata_id">
            <div
              v-if="iconDict.hasOwnProperty(item.meta_name)"
              class="ut-flex ut-rowcen"
              style="
                height: 30px;
                min-width: 40px;
                border-bottom: 1px solid var(--sprt-85);
              "
            >
              <img
                :src="iconDict[item.meta_name]"
                class="dt-icon v5"
                style="height: 20px; width: 20px"
              />
            </div>
           <!-- {{getBBValue(item.index)}} -->
            <!-- {{lastItemIndex}}::::::::{{item.index}} -->
            <TextField2
              v-if="lastItemIndex==item.index"
              style="width: 100%"
              :disabled="detailsObject.disabled"
              :id="item.metadata_id+''"
              :placeholder="$t(item.meta_name)"
              :label="$t(item.meta_name)"
              :value="item.metadata"
              :bb="'0px'"
              @blur="onTextFieldValueChange"
              :lw="'160px'"
            />
            <TextField2
              v-else
              style="width: 100%"
              :disabled="detailsObject.disabled"
              :id="item.metadata_id+''"
              :placeholder="$t(item.meta_name)"
              :label="$t(item.meta_name)"
              :value="item.metadata"

              @blur="onTextFieldValueChange"
              :lw="'160px'"
            />
          </div>
        </template>
        <!-- <div style="height: 30px; border-bottom: 1px solid var(--text-5)"></div> -->
      </template>
    </ExpandBox>
  </DBox>
</template>

<script>
import ExpandBox from "@plugins/expandable-box/expand-box";
export default {
  components: {
    ExpandBox,
  },
  props: {
    detailsObject: {
      required: true,
    },
  },

  data: function () {
    return {
      iconDict: {
        iTunes: "static/icons/itunes.png",
        Beatport: "static/icons/beatport.svg",
        Bandcamp: "static/icons/bandcamp.svg",
        Discogs: "static/icons/discogs.png",
        Amazon: "static/icons/amazon.svg",
      },
    };
  },

  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      // console.log("", name, value);
      this.$emit("changed", { kVal: name, value: value, name: "metadata" });
    },
    onDropdownChange: function (name, value) {
      this.$emit("changed", { name, value: value.value });
    },
    getBBValue:function(index){
      console.log("index:::",this.lastItemIndex==index)

      if(this.lastItemIndex==index){
        return '0px'
      }else{
        return '1px'
      }

    }
  },
  computed: {
    lastItemIndex:function(){

      // this.allItemMetadataEndpoints.forEach(e=>{
      //   console.log(this.allItemMetadata.filter(
      //       (x) => x.metadata_endpoint == e.metadata_endpoint
      //     ),"OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO",e);
      // })
      const lastEndpointIndex =this.allItemMetadataEndpoints.length-1;

      const lastEndPoint = this.allItemMetadataEndpoints[lastEndpointIndex];

      const lastMetaDataArray = this.allItemMetadata.filter(e=>e.metadata_endpoint==lastEndPoint.metadata_endpoint);

      const lastMetaDataIndex = lastMetaDataArray.length-1

      return lastMetaDataIndex;
    },

    allItemMetadataEndpoints: function () {
      return this.detailsObject.all_item_metadata_endpoints||[];
    },

    allItemMetadata: function () {

      const mappedEndPoints = this.allItemMetadataEndpoints.map(element => {
        return element.metadata_endpoint
        
      });
   

      return this.detailsObject.all_item_metadata.filter(
            (e) => mappedEndPoints.includes(e.metadata_endpoint) 
          ).map((x,index)=>{
            return{
              ...x,
              index
            }
      })||[];
    },
  },
};
</script>

<style lang="scss">
.cmp-catalog-products-product_setup {
}
</style>